import React from 'react';
import { Mail, Globe } from 'lucide-react';
export function Footer() {
  return <footer className="bg-night text-textLight py-8 border-t border-white/10" data-id="element-104">
      <div className="max-w-6xl mx-auto px-6 text-center" data-id="element-105">
        <div className="mb-8" data-id="element-106">
          <h2 className="text-2xl font-bold text-white mb-2 font-serif" data-id="element-107">
            🏛️ BIBLIOTECAS DIGITALES™
          </h2>
          <p className="text-textLight mb-2" data-id="element-108">
            El sistema N°1 para mujeres 40+ que quieren trabajar como Secretaria
            Virtual desde casa.
          </p>
          <p className="text-gold-accent/90 italic" data-id="element-109">
            Porque reinventarse no debería costarte años de frustración.
          </p>
        </div>

        <div className="flex flex-col md:flex-row justify-center items-center gap-6 mb-12 text-sm" data-id="element-110">
          <a href="mailto:soportebibliotecasdigitales@gmail.com" className="flex items-center gap-2 hover:text-white transition-colors" data-id="element-111">
            <Mail className="w-4 h-4" data-id="element-112" /> soportebibliotecasdigitales@gmail.com
          </a>
          <span className="hidden md:inline opacity-30" data-id="element-113">|</span>
          <a href="https://www.bibliotecasdigitales.store" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-white transition-colors" data-id="element-114">
            <Globe className="w-4 h-4" data-id="element-115" /> www.bibliotecasdigitales.store
          </a>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs" data-id="element-116">
          <p data-id="element-117">
            © Bibliotecas Digitales™ 2024 — Todos los derechos reservados.
          </p>
          <p className="font-bold text-gold-accent text-sm" data-id="element-118">
            💪 "Tu próxima oportunidad laboral empieza hoy."
          </p>
        </div>
      </div>
    </footer>;
}